import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiCheckCircle, FiHome, FiFileText } = FiIcons;

function OrderConfirmation() {
  const location = useLocation();
  const order = location.state?.order;

  if (!order) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="text-government-600">Order not found</p>
          <Link to="/customer" className="text-primary-600 hover:underline">
            Return to dashboard
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-government-50 to-primary-50 py-12">
      <div className="max-w-2xl mx-auto p-6">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="bg-white rounded-xl shadow-xl p-8 text-center"
        >
          <div className="mb-6">
            <SafeIcon icon={FiCheckCircle} className="w-16 h-16 text-green-600 mx-auto mb-4" />
            <h1 className="text-3xl font-bold text-government-900 mb-2">
              Order Confirmed!
            </h1>
            <p className="text-government-600">
              Your order has been successfully placed
            </p>
          </div>

          <div className="bg-government-50 p-6 rounded-lg mb-6 text-left">
            <h3 className="font-semibold text-government-900 mb-4">
              Order Details
            </h3>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span>Order ID:</span>
                <span className="font-mono">{order.id.substring(0, 8)}</span>
              </div>
              <div className="flex justify-between">
                <span>Total:</span>
                <span className="font-semibold">£{order.total.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <span>Status:</span>
                <span className="capitalize text-yellow-600 font-medium">
                  {order.status}
                </span>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 p-4 rounded-lg mb-6">
            <p className="text-sm text-blue-800">
              <strong>Next Steps:</strong> Your order will be prepared for collection. 
              Please present this confirmation when you arrive at the prison.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/customer"
              className="flex-1 bg-primary-600 hover:bg-primary-700 text-white py-3 px-6 rounded-lg font-semibold transition-colors flex items-center justify-center space-x-2"
            >
              <SafeIcon icon={FiHome} className="w-5 h-5" />
              <span>Back to Home</span>
            </Link>
            <Link
              to="/customer/orders"
              className="flex-1 bg-white hover:bg-government-50 text-government-700 border-2 border-government-300 py-3 px-6 rounded-lg font-semibold transition-colors flex items-center justify-center space-x-2"
            >
              <SafeIcon icon={FiFileText} className="w-5 h-5" />
              <span>View Orders</span>
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default OrderConfirmation;